import React from 'react'
import DeletePeople from '../People/DeletePeople'

const DeleteStudent = () => <DeletePeople kind="student" />

export default DeleteStudent
